import { cloneDeep } from "lodash-es";
import Utils from "../../../../util";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface PlantProductDemandInterface {
 'RESULTS.DATA.TECHNICAL.SP'?: Record<string, ResultRow>;
 'RESULTS.DATA.TECHNICAL.ADDITIONAL_PRODUCTS'?: Record<string, ResultRow>;
 'RESULTS.DATA.TECHNICAL.IUP'?: Record<string, ResultRow>;
 'RESULTS.DATA.TECHNICAL.GP'?: Record<string, ResultRow>;
}

export class PlantProductDemand {
  'RESULTS.DATA.TECHNICAL.SP';
  'RESULTS.DATA.TECHNICAL.ADDITIONAL_PRODUCTS'?;
  'RESULTS.DATA.TECHNICAL.IUP';
  'RESULTS.DATA.TECHNICAL.GP';

  /** Sold Product */
  get sp() {
    return this['RESULTS.DATA.TECHNICAL.SP'];
  }
  set sp(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.TECHNICAL.SP'] = value;
  }
  get additionalProducts() {
    return this['RESULTS.DATA.TECHNICAL.ADDITIONAL_PRODUCTS'];
  }
  set additionalProducts(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.TECHNICAL.ADDITIONAL_PRODUCTS'] = value;
  }
  /** Internally Used Product (Demand) */
  get iup() {
    return this['RESULTS.DATA.TECHNICAL.IUP'];
  }
  set iup(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.TECHNICAL.IUP'] = value;
  }
  /** Gross Products */
  get gp() {
    return this['RESULTS.DATA.TECHNICAL.GP'];
  }
  set gp(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.TECHNICAL.GP'] = value;
  }

  constructor(param: PlantProductDemandInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.SP'] = Utils.ObjectMapper(param['RESULTS.DATA.TECHNICAL.SP'] || {}, Utils.toResultRows);

    if (param['RESULTS.DATA.TECHNICAL.ADDITIONAL_PRODUCTS']) {
      this['RESULTS.DATA.TECHNICAL.ADDITIONAL_PRODUCTS'] = Utils.ObjectMapper(
        param['RESULTS.DATA.TECHNICAL.ADDITIONAL_PRODUCTS'] || {},
        Utils.toResultRows
      )
    } else {
      delete this['RESULTS.DATA.TECHNICAL.ADDITIONAL_PRODUCTS'];
    }

    this['RESULTS.DATA.TECHNICAL.IUP'] = Utils.ObjectMapper(param['RESULTS.DATA.TECHNICAL.IUP'] || {}, Utils.toResultRows);
    this['RESULTS.DATA.TECHNICAL.GP'] = Utils.ObjectMapper(param['RESULTS.DATA.TECHNICAL.GP'] || {}, Utils.toResultRows);
  }

  deepCopy() {
    return new PlantProductDemand(cloneDeep(this));
  }
}